import { Chart } from '@frontend/chart/types';

export const IOTS_VOLUME_BY_STATUS_DONUT_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'online', data: [{ label: 'online', value: 6 }] },
        { name: 'none', data: [{ label: 'none', value: 5 }] },
        { name: 'offline', data: [{ label: 'offline', value: 1 }] }
    ]
};
